// @ts-nocheck
import { useMemo } from "react";

//scss
import "./style.scss";

//assets
import SvgBed from "assets/icons/js/SvgBed";

//components
import Carousel from "components/Carousel";

const ListingRoomsAndBedsOld = ({ roomsData, numBedrooms, numSleeps }: any) => {
	const roomsList = useMemo(
		() =>
			roomsData &&
			Object?.values(roomsData).map((room, index): any => {
				return (
					<div className="room-old" key={index}>
						<div className="sub-h3">{room.room}</div>
						{Number(room.DB) > 0 && (
							<>
								<div className="text-sm-light clr-grey">
									{room.DB} Double Bed(s)
								</div>
								<div className="icons">
									{new Array(Number(room.DB)).map((index) => (
										<SvgBed key={index} />
									))}
									<SvgBed />
								</div>
							</>
						)}
						{Number(room.SB) > 0 && (
							<>
								<div className="text-sm-light clr-grey">
									{room.SB} Single Bed(s)
								</div>
								<div className="icons">
									{new Array(Number(room.SB)).map((index) => (
										<SvgBed key={index} />
									))}
									<SvgBed />
								</div>
							</>
						)}
					</div>
				);
			}),
		[roomsData],
	);
	return (
		<section className="listing__rooms-beds-old">
			<div style={{ marginBottom: "20px" }}>
				<span className="text-sm-bold clr-black">Bedrooms : {numBedrooms}</span>
				<span className="text-sm-light clr-grey">Sleeps : {numSleeps}</span>
			</div>
			<Carousel>{roomsList}</Carousel>
		</section>
	);
};

export default ListingRoomsAndBedsOld;
